import partnerService from 'Services/PartnerService'
import userService from 'Services/UserService'

// initial state
const state = {
  partners: []
}

// getters
const getters = {
  partner: state => partnerId => state.partners.find(partner => partner.partnerId === partnerId) || null
}

const actions = {
  filterPartners: ({ commit }, { filterContext }) => {
    const { request, cancelToken } = partnerService.getAll(filterContext)

    const promise = new Promise((resolve, reject) => {
      request.then(result => {
        commit('setPartners', result.data)

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })

    return { promise, cancelToken }
  },

  getPartners: ({ dispatch }) => {
    return dispatch('filterPartners').then(({ promise }) => promise.then(result => result.data))
  },

  getPartner: ({ commit, state }, { partnerId }) => {
    return new Promise((resolve, reject) => {
      partnerService.get(partnerId).then(result => {
        commit(state.partners.some(item => item.partnerId === result.partnerId) ? 'updatePartner' : 'setPartner', result)

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },

  filterPartnerBusinesses: ({ commit, getters }, { partnerId, filterContext }) => {
    const { request, cancelToken } = partnerService.getBusinesses(partnerId, filterContext)

    const promise = new Promise((resolve, reject) => {
      request.then(result => {
        const partner = getters.partner(partnerId)
        partner.businesses = [].concat(partner.businesses, result)

        commit('updatePartner', partner)

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })

    return { promise, cancelToken }
  },

  getPartnerBusinesses: ({ dispatch }, { partnerId }) => {
    return dispatch('filterPartnerBusinesses', { partnerId }).then(({ promise }) => promise.then(result => result.data))
  },

  getPartnerCommissionPlans: ({ commit, getters }, { partnerId }) => {
    const { request, cancelToken } = partnerService.getCommissionPlans(partnerId)

    const promise = new Promise((resolve, reject) => {
      request.then(result => {
        const partner = getters.partner(partnerId)
        partner.commissionPlans = [].concat(partner.commissionPlans, result.data)

        commit('updatePartner', partner)

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })

    return { promise, cancelToken }
  },

  getPartnerCommissionPlan: ({ commit, getters }, { partnerId, commissionPlanId }) => {
    return new Promise((resolve, reject) => {
      partnerService.getCommissionPlan(partnerId, commissionPlanId).then(result => {
        const partner = getters.partner(partnerId)

        if (partner !== null) {
          if (partner.commissionPlans.some(item => item.id === commissionPlanId)) {
            partner.commissionPlans = partner.commissionPlans.map(item => item.id === commissionPlanId ? result : item)
          } else {
            partner.commissionPlans.push(result)
          }

          commit('updatePartner', partner)
        }

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getPartnerStatistics: ({ commit, getters }, { partnerId }) => {
    return new Promise((resolve, reject) => {
      partnerService.getStatistics(partnerId).then(result => {
        const partner = getters.partner(partnerId)
        partner.statistics = result.data

        commit('updatePartner', partner)

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },

  filterPartnerUsers: ({ commit, getters }, { partnerId, filterContext }) => {
    const { request, cancelToken } = partnerService.getUsers(partnerId, filterContext)

    const promise = new Promise((resolve, reject) => {
      request.then(result => {
        const partner = getters.partner(partnerId)
        partner.users = [].concat(partner.users, result)

        commit('updatePartner', partner)

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })

    return { promise, cancelToken }
  },

  getPartnerUsers: ({ dispatch }, { partnerId }) => {
    return dispatch('filterPartnerUsers', { partnerId }).then(({ promise }) => promise.then(result => result.data))
  },

  getPartnerUser: ({ commit }, { partnerId, userId }) => {
    return userService.get(userId).then(result => {
      /*
      const partner = getters.partner(partnerId)

      if (partner !== null) {
        if (partner.users.some(item => item.userId === result.userId)) {
          partner.users = partner.users.map(item => item.userId === result.userId ? result : item)
        } else {
          partner.users.push(result)
        }

        commit('updatePartner', partner)
      }
      */

      return result
    })
  },

  addPartnerUser: ({ dispatch }, { partnerId, user }) => {
    return partnerService.addUser(partnerId, user).then((result) => {
      return dispatch('getPartnerUser', { partnerId, userId: result.userId })
    })
  },

  updatePartnerUser: ({ dispatch }, { partnerId, userId, user }) => {
    return userService.updateUser(partnerId, userId, user).then(() => {
      return dispatch('getPartnerUser', { partnerId, userId })
    })
  }
}

// mutations
const mutations = {
  setPartners (state, partners) {
    state.partners = partners
  },

  setPartner (state, partner) {
    state.partners.push(partner)
  },

  updatePartner (state, partner) {
    state.partners = state.partners.map(item =>
      item.partnerId === partner.partnerId ? partner : item
    )
  },

  deletePartner (state, partnerId) {
    state.partners = state.partners.filter(partner => partner.partnerId !== partnerId)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
